import { Button, ListItem, ListItemAvatar, ListItemText, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { UserIcon } from "lib/user/user-icon"
import {
    buildChangedFieldsLabel,
    buildCheckpointLabel,
    buildVersionLabel,
    formatDateTime,
} from "../lib/task-version-utils"

export function TaskVersionItem({ item, selectedVersion, onSelectVersion, onOpenAtVersionTime }) {
    const authorName = item.author?.displayName || item.author?.UserName || "System"
    const approverName = item.approvedBy || "System"
    const checkpointLabel = buildCheckpointLabel(item)
    const changedFieldsLabel = buildChangedFieldsLabel(item.changedFields)
    const selected = item.version === selectedVersion

    return (
        <ListItem
            alignItems="flex-start"
            sx={{
                borderRadius: 1,
                bgcolor: selected ? "action.selected" : "transparent",
                flexDirection: "column",
                alignItems: "stretch",
                gap: 1,
            }}
        >
            <Stack direction="row" spacing={1.5} alignItems="flex-start">
                <ListItemAvatar sx={{ minWidth: 44 }}>
                    <UserIcon id={item.author?.id} />
                </ListItemAvatar>
                <ListItemText
                    primary={buildVersionLabel(item)}
                    secondary={
                        <>
                            <Typography component="span" variant="body2" color="text.primary">
                                {item.snapshot?.heading}
                            </Typography>
                            <br />
                            <Typography component="span" variant="caption" color="text.secondary">
                                {checkpointLabel} by {authorName}
                            </Typography>
                            <If value={changedFieldsLabel}>
                                <>
                                    <br />
                                    <Typography component="span" variant="caption" color="text.secondary">
                                        Changed: {changedFieldsLabel}
                                    </Typography>
                                </>
                            </If>
                            <If value={item?.approvedAt}>
                                <>
                                    <br />
                                    <Typography
                                        data-cy="task-version-approval-note"
                                        component="span"
                                        variant="caption"
                                        color="success.main"
                                    >
                                        Approved by {approverName} on {formatDateTime(item?.approvedAt)}
                                    </Typography>
                                </>
                            </If>
                        </>
                    }
                />
            </Stack>

            <Stack direction="row" spacing={1} justifyContent="flex-end">
                <Button size="small" variant={selected ? "contained" : "outlined"} onClick={handleSelect}>
                    View
                </Button>
                <Button size="small" variant="text" onClick={handleOpenAtVersionTime}>
                    Open Library Here
                </Button>
            </Stack>
        </ListItem>
    )

    function handleSelect() {
        onSelectVersion(selected ? null : item.version)
    }

    function handleOpenAtVersionTime() {
        onOpenAtVersionTime(item.createdAt, item.version)
    }
}
